<template>
    <PostCard @CREATE="CREATE($event)"/>
</template>

<script>
import PostCard from '@/components/basic/PostCard.vue'
import customToasts from '@/mixins/customToasts'

export default {
    mixins:[customToasts],
    components: { PostCard },
    props:{
        content:{}
    },
    methods:{
        async CREATE(postedComplain){
            
            const res = await this.$axios.post('complains', {
                ...postedComplain,
                fullPath: this.$route.fullPath,
                complainedContent: this.content
            })

            if(res){
                this.showToast('Ваша жалоба отправлена и будет рассмотрена администрацией.', 'success', 5000)
            }
        }
    }
}
</script>